_ = require 'underscore'

# Mixing-in classes must implement a labelCreateUrl method and have a
# labelList property that the mixin can access.
class LabelsHelper
  getLabels: ->
    @labelList.models

  dataForLabel: (label) ->
    _.extend label.toJSON(), { isActive: @hasLabel(label) }

  toggleLabelColor: (color) ->
    label = @getBoard().labelForColor(color)
    if label?
      @toggleLabel(label)

  hasLabel: (label) ->
    @labelList.contains(label)

  toggleLabel: (label) ->
    toggleOn = !@hasLabel(label)
    @toggle('idLabels', label.id, toggleOn)

  createLabel: (name, color) ->
    label = _.find @getBoard().getLabels(), (label) ->
      label.get('name') == name && label.get('color') == color
    if label
      if !@hasLabel(label) then @toggleLabel(label)
      return

    @labelList.create(
      { name, color: color ? '', idBoard: @get('idBoard') }
      { url: @labelCreateUrl() }
    )
    return

module.exports = LabelsHelper
